import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid } from '@mui/material';
import CommonTable from 'components/commonTable/CommonTable';
import AllotDialog from 'components/allotDialog/AllotDialog';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import { useDispatch, useSelector } from 'react-redux';
import { getAssignDriver, getTrip } from 'redux/actions/UserTrip';
import Loader from 'components/loader/Loader';
import { updateAssignDriver } from 'redux/actions/UserAllot';


function AssignTripView() {
  const [value, setValue] = useState('requested');
  const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();
  const assignDriverData = useSelector((state) => state?.userAssignDriver?.userAssignDriver?.data)
  const assignDriverLoader = useSelector((state) => state?.userAssignDriver?.loading)
  const trips = useSelector((state) => state?.userTrip?.userTrip?.data)
  const loader = useSelector((state) => state?.userTrip?.loading)
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDrivers, setFilterDrivers] = useState(assignDriverData)
  const [tripId, setTripId] = useState('')
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [locationData, setLocationData] = useState({});

  const id = localStorage.getItem('companyId')
  const userId = localStorage.getItem('ID')

  let filterData = {
    assignId: id,
    status: value,
    page: page,
    pageSize: rowsPerPage,
    type: ""
  }
  let filterDataDriver = {
    assignId: userId,
    status: 'assignTrip',
    page: "",
    pageSize: "",
    type: ""
  }


  useEffect(() => {
    filterAllDrivers()
  }, [searchQuery])

  useEffect(() => {
    setFilterDrivers(assignDriverData)
  }, [assignDriverData])


  useEffect(() => {
    dispatch(getTrip(filterData))
  }, [])

  const onClickTableVendor = (data) => {
    if (value !== 'cancelled') {
      setTripId(data?.id)
      dispatch(getAssignDriver({tripId:data?.id}));
      setLocationData(data)
      setOpenDialog(true);
      setSearchQuery("")
    }
  };

  const submittAssign = (data) => {
    const val = {
      tripId: tripId,
      driverId: data?.id,
      status: value,
      driverData: filterDataDriver
    }
    dispatch(updateAssignDriver(val));
    handleClose();
  }

  const handleClose = () => {
    setOpenDialog(false);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(0);
    filterData = { ...filterData, status: newValue, page:0, }
    dispatch(getTrip(filterData))
  };

  const breadcrumbPaths = [
    { name: 'Assign Trip', url: '', className: 'colorBlue' },
  ];

  const handelSearch = (val) => {
    setSearchQuery(val)
  }

  const filterAllDrivers = () => {
    let filteredDriverList = [];

    if (searchQuery !== "") {
      filteredDriverList = assignDriverData.filter(driver => driver.driverName.toLowerCase().includes(searchQuery?.toLowerCase()))
    } else {
      filteredDriverList = assignDriverData
    }

    setFilterDrivers(filteredDriverList)

  }

  const handleChangePage = (event,newPage) =>{
    setPage(newPage)
    filterData = {...filterData, page:newPage}
    dispatch(getTrip(filterData))
  }

  const handleChangeRowsPerPage = (event) =>{
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    filterData = {...filterData, page:0, pageSize:parseInt(event.target.value)}
    dispatch(getTrip(filterData))
  }

  return (
    <div>
      <CommonBreadCrumb paths={breadcrumbPaths} />
      {loader ?
        <Loader />
        :
        <Grid container>
          <Grid item className="tableContainer" xs={12}>
            <Box className="contentBoxStyle">
              <TabContext value={value}>
                <Grid
                  container
                  className="tabBoxStyle"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <TabList
                      className='minHeight32'
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                      TabIndicatorProps={{
                        style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                      }}
                    >
                      <Tab label="Requested" value="requested" className="tabStyle" />
                      <Tab label="Assigned" value="assigned" className="tabStyle" />
                      <Tab label="Cancelled" value="cancelled" className="tabStyle" />
                    </TabList>
                  </Grid>
                </Grid>
                <TabPanel
                  value="requested"
                  sx={{ width: '100%' }}
                  className="vendotTable"
                >
                  <CommonTable 
                    data={trips} 
                    onClickTableVendor={onClickTableVendor}
                    actionBtn="true" 
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable = {false}
                  />
                </TabPanel>
                <TabPanel value="cancelled" className="vendotTable">
                  <CommonTable 
                    data={trips} 
                    onClickTableVendor={onClickTableVendor} 
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable = {false}
                  />
                </TabPanel>
                <TabPanel value="assigned" className="vendotTable">
                  <CommonTable 
                    data={trips} 
                    onClickTableVendor={onClickTableVendor} 
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable = {false}
                  />
                </TabPanel>
              </TabContext>
            </Box>
          </Grid>
        </Grid>}
      {openDialog && (
        <AllotDialog
          onSearch={handelSearch}
          type={"tripView"}
          openDialog={openDialog}
          allotData={filterDrivers}
          title={'Available'}
          subtitle={"Pickup location - "+locationData?.sourceAddress}
          titleType={'Driver'}
          placeholder={'Search driver'}
          handleClose={handleClose}
          submittAssign={submittAssign}
          loader={assignDriverLoader}
        />
      )}
    </div>
  );
}

export default AssignTripView;
